import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, finalize } from 'rxjs';

import { GlobalLoaderService } from '@shared/components/global-loader/global-loader.service';

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {
  private readonly timeout = 400;

  constructor(private loaderService: GlobalLoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.loaderService.incrementXhrNumber(this.timeout);
    return next
      .handle(request)
      .pipe(
        finalize(() => this.loaderService.decrementXhrNumber(this.timeout))
      );
  }
}
